<div class="flex flex-col gap-medpace">
    <medpace-flight-details
        id="patientFlightDetails"
        class="w-full"
        [mode]="mode()"
        [formGroup]="formGroup().controls.patientFlightDetails"
        [noFlightOption]="false"
    />
    @if (mode() === 'edit' && hasAnyNonDisabledCaregiverControls(this.formGroup().controls.caregivers.controls)) {
        <div>
            <span> Accompanying caregivers: </span>
            @for (caregiverFormGroup of formGroup().controls.caregivers.controls; track caregiverFormGroup) {
                <div class="flex items-baseline">
                    @if (!caregiverFormGroup.disabled) {
                        <mds-expansion-panel
                            id="caregiverFlightDetails_ExpansionPanel"
                            class="expansion-panel-request w-full !border-y-0"
                            [panelTitle]="getCaregiverFullName(caregiverFormGroup.value.caregiver)"
                            [description]="'Book the same flight as for the patient'"
                            [disabled]="!!caregiverFormGroup.value.details?.bookIdenticalTrip"
                            [expanded]="!caregiverFormGroup.value.details?.bookIdenticalTrip"
                        >
                            <div class="expansion-panel-checkbox" mds-header-content>
                                <mds-checkbox
                                    id="bookTheSameFlight_Checkbox"
                                    class="w-min"
                                    [formCtrl]="caregiverFormGroup.controls.details.controls.bookIdenticalTrip"
                                />
                            </div>
                            <medpace-flight-details
                                class="w-full"
                                [mode]="mode()"
                                [formGroup]="caregiverFormGroup.controls.details.controls.flightDetails"
                            />
                        </mds-expansion-panel>
                    }
                </div>
            }
        </div>
    } @else if (mode() === 'view' && accompanyingCaregivers().length > 0) {
        <div>
            <span>Accompanying caregivers:</span>
            @for (caregiverFormGroup of accompanyingCaregivers(); track caregiverFormGroup.value.caregiver?.id) {
                <div class="flex items-baseline">
                    <mds-expansion-panel
                        class="expansion-panel-request w-full !border-y-0"
                        [panelTitle]="getCaregiverFullName(caregiverFormGroup.value.caregiver)"
                        [description]="
                            caregiverFormGroup.controls.details.controls.bookIdenticalTrip.value
                                ? 'The same flight was booked as for the patient'
                                : ''
                        "
                        [disabled]="false"
                        [expanded]="false"
                    >
                        <medpace-flight-details
                            class="w-full"
                            [mode]="mode()"
                            [formGroup]="caregiverFormGroup.controls.details.controls.flightDetails"
                        />
                    </mds-expansion-panel>
                </div>
            }
        </div>
    }
</div>
